import { call, put, takeEvery } from 'redux-saga/effects';
import { message } from 'antd';
import { udhyamCategoriesAPI } from '../../api/config';
import * as types from '../constants/actionTypes';
import * as actions from '../actions/udhyamCategoryActions';

// Fetch All Udhyam Categories Saga
function* fetchUdhyamCategoriesSaga(action) {
  try {
    const response = yield call(udhyamCategoriesAPI.fetchUdhyamCategories, action.payload.filters);
    const { udhyam_categories, total_count } = response.data;
    
    yield put(actions.fetchUdhyamCategoriesSuccess(udhyam_categories, total_count));
  } catch (error) {
    const errorMessage = error.response?.data?.message || 'Failed to fetch udhyam categories';
    yield put(actions.fetchUdhyamCategoriesFailure(errorMessage));
    message.error(errorMessage);
  }
}

// Fetch Active Udhyam Categories Saga
function* fetchActiveUdhyamCategoriesSaga(action) {
  try {
    const response = yield call(udhyamCategoriesAPI.fetchActiveUdhyamCategories);
    const { udhyam_categories, total_count } = response.data;
    
    yield put(actions.fetchActiveUdhyamCategoriesSuccess(udhyam_categories, total_count));
  } catch (error) {
    const errorMessage = error.response?.data?.message || 'Failed to fetch active udhyam categories';
    yield put(actions.fetchActiveUdhyamCategoriesFailure(errorMessage));
    message.error(errorMessage);
  }
}

// Get Udhyam Category by ID Saga
function* getUdhyamCategorySaga(action) {
  try {
    const { id } = action.payload;
    const response = yield call(udhyamCategoriesAPI.getUdhyamCategory, id);
    const { udhyam_category } = response.data;
    
    yield put(actions.getUdhyamCategorySuccess(udhyam_category));
  } catch (error) {
    const errorMessage = error.response?.data?.message || 'Failed to fetch udhyam category';
    yield put(actions.getUdhyamCategoryFailure(errorMessage));
    message.error(errorMessage);
  }
}

// Create Udhyam Category Saga
function* createUdhyamCategorySaga(action) {
  try {
    const response = yield call(udhyamCategoriesAPI.createUdhyamCategory, action.payload.categoryData);
    const { udhyam_category } = response.data;
    
    yield put(actions.createUdhyamCategorySuccess(udhyam_category));
    message.success('Udhyam category created successfully');
    
    // Refresh the list
    yield put(actions.fetchUdhyamCategoriesRequest({}));
  } catch (error) {
    const errorMessage = error.response?.data?.message || 'Failed to create udhyam category';
    yield put(actions.createUdhyamCategoryFailure(errorMessage));
    message.error(errorMessage);
  }
}

// Update Udhyam Category Saga
function* updateUdhyamCategorySaga(action) {
  try {
    const { id, categoryData } = action.payload;
    const response = yield call(udhyamCategoriesAPI.updateUdhyamCategory, id, categoryData);
    const { udhyam_category } = response.data;
    
    yield put(actions.updateUdhyamCategorySuccess(udhyam_category));
    message.success('Udhyam category updated successfully');
    
    // Refresh the list
    yield put(actions.fetchUdhyamCategoriesRequest({}));
  } catch (error) {
    const errorMessage = error.response?.data?.message || 'Failed to update udhyam category';
    yield put(actions.updateUdhyamCategoryFailure(errorMessage));
    message.error(errorMessage);
  }
}

// Root Udhyam Category Saga
export default function* udhyamCategorySaga() {
  yield takeEvery(types.FETCH_UDHYAM_CATEGORIES_REQUEST, fetchUdhyamCategoriesSaga);
  yield takeEvery(types.FETCH_ACTIVE_UDHYAM_CATEGORIES_REQUEST, fetchActiveUdhyamCategoriesSaga);
  yield takeEvery(types.GET_UDHYAM_CATEGORY_REQUEST, getUdhyamCategorySaga);
  yield takeEvery(types.CREATE_UDHYAM_CATEGORY_REQUEST, createUdhyamCategorySaga);
  yield takeEvery(types.UPDATE_UDHYAM_CATEGORY_REQUEST, updateUdhyamCategorySaga);
}